import type {
  SystemScenarioRunRecord,
} from './SystemWorkspaceContracts';

import {
  ControlledSystemSimulatorEngine,
} from './ControlledSystemSimulatorEngine';

import {
  getSystemWorkspace,
} from './SystemWorkspaceRegistry';

import {
  MEMBERSHIP_BILLING_SYSTEM_ID,
  MEMBERSHIP_SCENARIO_IDS,
  membershipBillingScenarios,
  registerMembershipBillingScenarioPackage,
  type MembershipScenarioId,
} from './MembershipBillingScenarioPackage';

registerMembershipBillingScenarioPackage();

const membershipSimulator =
  new ControlledSystemSimulatorEngine(
    getSystemWorkspace,
    {
      timeoutMs: 5_000,
    },
  );

export function listMembershipBillingScenarios() {
  return [...membershipBillingScenarios];
}

export function listMembershipBillingSimulationRuns() {
  return membershipSimulator.listRuns(
    MEMBERSHIP_BILLING_SYSTEM_ID,
  );
}

export function listMembershipBillingSimulationEvidence() {
  return membershipSimulator.listEvidence(
    MEMBERSHIP_BILLING_SYSTEM_ID,
  );
}

export async function runMembershipBillingScenario(
  scenarioId: MembershipScenarioId,
): Promise<SystemScenarioRunRecord> {
  return membershipSimulator.execute(
    MEMBERSHIP_BILLING_SYSTEM_ID,
    scenarioId,
  );
}

export async function runAllMembershipBillingScenarios():
  Promise<SystemScenarioRunRecord[]> {
  const results:
    SystemScenarioRunRecord[] = [];

  for (
    const scenarioId of
    MEMBERSHIP_SCENARIO_IDS
  ) {
    results.push(
      await runMembershipBillingScenario(
        scenarioId,
      ),
    );
  }

  return results;
}
